<template>
  <div class="flex justify-between" :class="col ? 'flex-direction' : ''">
    <div class="realTimeAlarm flex justify-around margin-top-sm">
      <div style="">
        <Echart
          :options="options"
          id="equipmentFailure"
          :height="curHeight + 'px'"
          :width="curWidth + 'px'"
        ></Echart>
      </div>
      <!-- <div class="flex flex-direction text-white justify-center"> -->
        <div class="text-xsss flex flex-direction align-center justify-center">
          设备故障率：
          <span class="text-df  text-bold">{{alarmRateInfo.AlarmRate}}</span>
        </div>
        <div class="text-xsss flex flex-direction align-center justify-center">
          对比上个月：<span class="text-df  text-bold">{{
            alarmRateInfo.alarmRateAdd
          }}</span>
        </div>
      <!-- </div> -->
    </div>
    <div class="realTimeAlarm flex justify-around margin-top-sm">
      <div style="">
        <Echart
          :options="options1"
          id="equipmentFailure"
          :height="curHeight + 'px'"
          :width="curWidth + 'px'"
        ></Echart>
      </div>
      <!-- <div class="flex flex-direction text-white justify-center"> -->
        <div class="text-xsss flex flex-direction align-center justify-center">
          设备停站时长：<span class="text-df  text-bold">{{
            alarmRateInfo.StopStationLong
          }}</span>
        </div>
        <div class="text-xsss flex flex-direction align-center justify-center">
          对比上个月：<span class="text-df  text-bold">{{
            alarmRateInfo.stopStationLongAdd
          }}</span>
        </div>
      <!-- </div> -->
    </div>
    <div class="realTimeAlarm flex justify-around margin-top-sm">
      <div style="">
        <Echart
          :options="options2"
          id="equipmentFailure"
          :height="curHeight + 'px'"
          :width="curWidth + 'px'"
        ></Echart>
      </div>
      <!-- <div class="flex flex-direction text-white justify-center"> -->
        <div class="text-xsss flex flex-direction align-center justify-center">
          设备停站故障率：<span class="text-df  text-bold">{{
            alarmRateInfo.StopStationRate
          }}</span>
        </div>
        <div class="text-xsss flex flex-direction align-center justify-center">
          对比上个月：<span class="text-df  text-bold">{{
            alarmRateInfo.stopStationRateAdd
          }}</span>
        </div>
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import Echart from '@/common/echart';
import { getSizeByScreen } from '@/utils/index';
import { dataInterface } from '@/api/dataInterfaceApi';

export default {
  data() {
    return {
      curHeight: 100,
      curWidth: 100,
      alarmRateInfo: {
        alarmRate: 0,
        alarmRateAdd: 0,
        stopStationLong: 0,
        stopStationLongAdd: 0,
        stopStationLong: 0,
        stopStationRateAdd: 0,
      },
      options: {
        color: ['#43FFB9', '#1F3762'],
        tooltip: {
          trigger: 'item',
        },
        graphic: {
          type: 'text',
          left: 'center',
          top: 'center',
          style: {
            text: '0%',
            textAlign: 'center',
            fill: '#fff',
            fontSize: 12,
            fontWeight: 400,
          },
        },
        series: [
          {
            name: '访问来源',
            type: 'pie',
            radius: ['50%', '70%'],
            center: ['50%', '50%'],
            data: [{ value: 1048 }, { value: 735 }],
            labelLine: {
              show: false,
            },
            label: {
              show: true,
            },
          },
        ],
      },
      options1: {
        color: ['#129BFF', '#1F3762'],
        tooltip: {
          trigger: 'item',
        },
        graphic: {
          type: 'text',
          left: 'center',
          top: 'center',
          style: {
            text: '0.12%',
            textAlign: 'center',
            fill: '#fff',
            fontSize: 12,
            fontWeight: 400,
          },
        },
        series: [
          {
            name: '访问来源',
            type: 'pie',
            radius: ['50%', '70%'],
            center: ['50%', '50%'],
            data: [{ value: 1048 }, { value: 735 }],
            labelLine: {
              show: false,
            },
            label: {
              show: true,
            },
          },
        ],
      },
      options2: {
        color: ['#31FBFB', '#1F3762'],
        tooltip: {
          trigger: 'item',
        },
        graphic: {
          type: 'text',
          left: 'center',
          top: 'center',
          style: {
            text: '0.12%',
            textAlign: 'center',
            fill: '#fff',
            fontSize: 12,
            fontWeight: 400,
          },
        },
        series: [
          {
            name: '访问来源',
            type: 'pie',
            radius: ['50%', '70%'],
            center: ['50%', '50%'],
            data: [{ value: 1048 }, { value: 735 }],
            labelLine: {
              show: false,
            },
            label: {
              show: true,
            },
          },
        ],
      },
    };
  },
  components: {
    Echart,
  },
  props: {
    col: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    curWidth: {
      handler(newData) {
        this.curWidth = this.width ? this.width : 100;
        //适配代码
        // this.curWidth = getSizeByScreen(100);
      },
      immediate: true,
      deep: true,
    },
    curHeight: {
      handler(newData) {
        this.curHeight = this.height ? this.height : 100;
        //适配代码
        // this.curHeight = getSizeByScreen(100);
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {},
  methods: {
    getData(data) {
      this.selectStationAlarmRateInfo(data);
    },
    selectStationAlarmRateInfo(data = {}) {
      let _this = this;
      let params = {
					"enCode":"guzhanglvtongji-TiDB",
    			"@station_id":data.stationId
				}
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if (!res) return;
          res = res[0];
          this.alarmRateInfo = res;
          this.options.graphic.style.text = res.AlarmRate;
          this.options1.graphic.style.text = res.StopStationLong;
          this.options2.graphic.style.text = res.StopStationRate;

          this.option.series[0].data[0].value = res.AlarmRate.split("%")[0];
          this.option1.series[0].data[0].value = res.StopStationLong.split("%")[0];
          this.option2.series[0].data[0].value = res.StopStationRate.split("%")[0];
          // this.options.series[0].data
          // alarmRate设备故障率、alarmRateAdd对比上月、stopStationLong停战时长、stopStationLongAdd对比上月、stopStationLong设备停战故障率、stopStationRateAdd对比上月
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.realTimeAlarm {
  width: 460px;
  height: 90px;
  background: linear-gradient(
    180deg,
    rgba(47, 164, 159, 0.11) 0%,
    rgba(1, 177, 169, 0.06) 79%,
    rgba(53, 149, 147, 0.11) 100%
  );
}
.aaaa {
  width: 100px;
  height: 100px;
}
</style>
